import merge from 'lodash/merge';
// date fns
import { fr as frFRAdapter, enUS as enUSAdapter, es as esESAdapter } from 'date-fns/locale';

// core (MUI)
import { enUS as enUSCore, frFR as frFRCore, esES as esESCore } from '@mui/material/locale';
// data grid (MUI)
import { enUS as enUSDataGrid, frFR as frFRDataGrid, esES as esESDataGrid } from '@mui/x-data-grid';
// date pickers (MUI)
import { enUS as enUSDate, frFR as frFRDate, esES as esESDate } from '@mui/x-date-pickers/locales';

// PLEASE REMOVE `LOCAL STORAGE` WHEN YOU CHANGE SETTINGS.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: 'Spanish',
    value: 'es',
    systemValue: merge(esESDate, esESDataGrid, esESCore),
    adapterLocale: esESAdapter,
    icon: 'flagpack:es',
    numberFormat: {
      code: 'es',
      currency: 'CLP',
    },
  },
  {
    label: 'Kréyol Ayisyen',
    value: 'ht',
    systemValue: merge(frFRDate, frFRDataGrid, frFRCore),
    adapterLocale: frFRAdapter,
    icon: 'flagpack:ht',
    numberFormat: {
      code: 'ht',
      currency: 'HTG',
    },
  },
  {
    label: 'Français',
    value: 'fr',
    systemValue: merge(frFRDate, frFRDataGrid, frFRCore),
    adapterLocale: frFRAdapter,
    icon: 'flagpack:fr',
    numberFormat: {
      code: 'ht',
      currency: 'EUR',
    },
  },
  {
    label: 'English',
    value: 'en',
    systemValue: merge(enUSDate, enUSDataGrid, enUSCore),
    adapterLocale: enUSAdapter,
    icon: 'flagpack:gb-nir',
    numberFormat: {
      code: 'ht',
      currency: 'USD',
    },
  },
];

export const defaultLang = allLangs[1]; // Francais

// GET MORE COUNTRY FLAGS
// https://icon-sets.iconify.design/flagpack/
// https://www.dropbox.com/sh/nec1vwswr9lqbh9/AAB9ufC8iccxvtWi3rzZvndLa?dl=0
